import React, { forwardRef, useState, useEffect } from 'react';
import DishImageComponent from "../components/DishImageBlock";
import DishDescription from "../components/DishDescription";
import ReportAdditionalInfo from "../components/ReportAdditionalInfo";
import ReportParameterDetails from "../components/ReportParameterDetails";
// import ReportTransparentCard from "../components/ReportTransparentCard";
// import DishCountryInfo from "../components/DishCountryInfo";
import ReportParameterDescriptions from "../components/ReportParameterDescriptions";
import DishesIngredientsInformation from "../components/DishesIngredientsInformation";
import DishesNutritionInformation from "../components/DishesNutritionInformation";
import { useTranslation } from '../../hooks/useTranslation';


const DishPDFFile = forwardRef(({ dish, dishData, EthicComponent }, ref) => {

  const [co2eValue, setCO2eValue] = useState(0);
  // const [countryName, setCountryName] = useState(null);
  const { t } = useTranslation();


  useEffect(() => {
    if (dish) {
      setCO2eValue(dish.CO2e_menuwise);
    }
  }, [dish])

  return (
    <div ref={ref}>
      <div className="page-break-after-always">
          <div className='grid grid-cols-[5fr_5fr]'>
            {/* <div className="w-full grid grid-cols-[3fr_8fr]"> */}
              <DishImageComponent dish={dish} t={t} />
              <DishDescription
                dish={dish}
                EthicComponent={EthicComponent}
                t={t}
              />
            {/* </div> */}
            {/* Transparency Section is hidden in the print layout for now*/}
            {/* <div className='flex flex-col justify-between border-l-[1.5px] border-gray-300'>
              <div className="flex flex-row items-center border-l-[1.5px] border-gray-300 px-3">
                <ReportTransparentCard score={dishData?.transparency || 0} t={t} />
               <img
                  className="w-[7.5rem] h-[7.5rem] ml-2"
                  src="/assets/icons/consu-transp.png"
                  alt={t("Transparency Icon")}
                  style={{ transform: 'translateY(-5px)' }}
                />
              </div>
            </div> */}
          </div>
        <ReportParameterDetails dish={dish} />
        <ReportAdditionalInfo productData={dishData} certificates={dish?.certificates} co2e={co2eValue && co2eValue} dish={dish}/>
      </div>
      <DishesIngredientsInformation dish={dish} />
      <DishesNutritionInformation dish={dish} />
      <ReportParameterDescriptions dish={dish} />

      {/* Footer Section */}
      {/* <div className="footer text-center py-4 border-t">
        <p>© {new Date().getFullYear()} www.consupedia.com. {t("All rights reserved.")}</p>
      </div> */}
    </div>
  );
})

export default DishPDFFile;